export class Timeline {
  constructor ( callback ) {
    this.start = this.start.bind(this)
    this.reinit = this.reinit.bind(this)
    this.onUpdate = this.onUpdate.bind(this)
    this.clearData = this.clearData.bind(this)
    this.setData = this.setData.bind(this)

    this.startTime = 0
    this.isStarted = false
    this.callback = callback
    this.data = []
  }

  setData ( data ) {
    if (data === void 0) {
      console.warn('timeline needs data')
      return
    }

    this.data = [...data]
    this.time = 0
    this.data.forEach(datum => { datum.isStarted = false })
  }

  clearData () {
    this.data = []
    this.time = 0
  }

  onUpdate( elapsed ) {
    this.time = elapsed

    if ( !this.isStarted ) { return }

    this.data.forEach( datum => {
      if (this.time >= datum.timeSeconds && !datum.isStarted) {
        datum.isStarted = true
        this.callback(datum)
      }
    })
  }
  start () {
    this.isStarted = true
  }

  reinit () {
    this.data.forEach(datum => {
      datum.isStarted = false
    })
    this.start()
  }

  checkEventStatus () {
    if (this.data.filter(datum => !datum.isStarted).length === 0) {
      this.onDestroy()
    }
  }
}